export const PATHS = {
  relatedView: 'related-view',
  exportFile: 'export-file',
} as const;
